import React, { useEffect, useState } from 'react'
import { FaArrowUp } from 'react-icons/fa'

const ScrollToTop = () => {
  const [scrolled, setScrolled] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 50) {
        setScrolled(true); // User scrolled past 50px
      } else {
        setScrolled(false); // User is at the top
      }
    };

    window.addEventListener("scroll", handleScroll);
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);
  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth", // Smooth scroll to top
    });
  };
  return (
    <button
      onClick={scrollToTop}
      aria-label='scrolltotop'
      style={{
        backgroundColor: "#0B1C3D",
        display: scrolled ? "flex" : "none", // Show only if scrolled
        justifyContent: "center",
        alignItems: "center",
        position: "fixed",
        bottom: "40px", // Fixed position at the bottom-right corner
        right: "20px",
        width: "50px",
        height: "50px",
        borderRadius: "50%", // Circular shape
        zIndex: 1000,
        boxShadow: "0 4px 6px rgba(0,0,0,0.1)",
        cursor: "pointer",
        transition: "opacity 0.3s ease", // Smooth transition for appearance/disappearance
      }}
      className=" btn btn-lg btn-lg-square back-to-top border-2 border-[#D4AF37]"
    >
      <FaArrowUp color="white" size={20} />
    </button>
  )
}

export default ScrollToTop
